export default (htmlString) => {
  const regex = /<.(.*?)>/g; //finds every html tag
  const extractedString = htmlString?.replace(regex, ''); //all matches will be removed

  return extractedString; //returns new string
};
